/* Mandalas — header transparent sur la home, opaque au scroll */
(function () {
  if (!document.body.classList.contains('cc-transparent-header')) return;
  var THRESHOLD = 60;

  function annBar() {
    // la section bandeau d'annonces du groupe header
    return document.querySelector('.shopify-section-group-header-group.announcement-bar-section')
        || document.querySelector('.announcement-bar-section')
        || document.querySelector('.shopify-section-group-header-group:not(:has(.header-wrapper))');
  }

  function headerSection() {
    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].querySelector('.header-wrapper')) return sections[i];
    }
    return null;
  }

  function setHeights() {
    var bar = annBar();
    document.body.style.setProperty('--cc-ann-h', (bar ? bar.offsetHeight : 0) + 'px');
    var hd = headerSection();
    document.body.style.setProperty('--cc-header-h', (hd ? hd.offsetHeight : 0) + 'px');
  }

  function onScroll() {
    if (window.scrollY > THRESHOLD) {
      document.body.classList.add('cc-header-solid');
    } else {
      document.body.classList.remove('cc-header-solid');
    }
  }

  function update() { setHeights(); onScroll(); }

  // Quand le tiroir menu (mobile) s'ouvre, on force le header en mode opaque
  // pour que le menu s'affiche correctement, même en haut de page.
  function bindDrawer() {
    var details = document.querySelector('header-drawer details');
    if (!details) return;
    details.addEventListener('toggle', function () {
      if (details.open) {
        document.body.classList.add('cc-header-solid', 'cc-menu-open');
      } else {
        document.body.classList.remove('cc-menu-open');
        onScroll();
      }
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('load', update);
  document.addEventListener('DOMContentLoaded', function () { update(); bindDrawer(); });
  update();
  bindDrawer();
})();
